import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b8aed75"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " View Original Media ", -1))
const _hoisted_3 = [
  _hoisted_2
]

import { onMounted, ref } from 'vue';

type ImageProps = {
  arweaveUrl: string | null | undefined;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ViewOriginalMedia',
  props: {
    arweaveUrl: null
  },
  setup(__props: any) {

const props = __props as {
  arweaveUrl: string | null | undefined;
};

const mediaArweaveUrl = ref('');

onMounted(async () => {
  // get on-chain data on load
  try {
    mediaArweaveUrl.value = await getMediaArweaveUrl();
  } catch (e) {
    console.warn('Arweave url lookup error', e);
  }
});



const getMediaArweaveUrl = async (): Promise<string> => {
  if (props.arweaveUrl) {
    const arweaveUrl = await parseTokenMetadata(props.arweaveUrl);
    return arweaveUrl;
  }
  return '';
};

const parseTokenMetadata = async (url: string): Promise<string> => {
  const response = await fetch(url);

  const metadata = await response.json();
  return (
    metadata.animation_url ||
    metadata.animation ||
    metadata.image_url ||
    metadata.image
  );
};

return (_ctx: any,_cache: any) => {
  return (mediaArweaveUrl.value)
    ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        class: "campaign-view-original-media",
        target: "_blank",
        href: mediaArweaveUrl.value
      }, _hoisted_3, 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})